module.exports = __webpack_public_path__ + "static/media/test-execution-time-full.7de84f9d.svg";